module.exports = __webpack_public_path__ + "static/route_plan-c6d35c243fa23e9cfeb80b406aef5213.jpg";